import profileimg from 'assets/images/profileimg.png';
import { useAuthenticatedBlobUrl } from 'hooks/useAuthenticatedBlobUrl';
import React, { type CSSProperties } from 'react';

type AuthenticatedImageProps = {
  alt?: string;
  fileId?: string | null;
  fallbackSrc?: string;
  style?: CSSProperties;
};

export function AuthenticatedImage({
  fileId,
  fallbackSrc = profileimg,
  style,
  alt = '',
}: AuthenticatedImageProps) {
  const { url } = useAuthenticatedBlobUrl(fileId ?? null);
  return <img alt={alt} src={url ?? fallbackSrc} style={style} />;
}
